// Library Methods
import { useMutation, useQueryClient } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// API
import { getReportSectionData } from "../../api";

export const useReportSectionData = (clinicId: string | undefined) => {
  const queryClient = useQueryClient();
  const { getToken } = useTokenAccess();

  return useMutation({
    mutationFn: async (params: {
      patientId: string;
      examId: string;
      sectionId: string;
    }) => {
      if (!clinicId) throw new Error();

      try {
        const token = await getToken();
        const controller = new AbortController();
        return getReportSectionData(
          token,
          clinicId,
          params.patientId,
          params.examId,
          params.sectionId,
          controller.signal
        );
      } catch (error) {
        throw error;
      }
    },
    // Invalidate query cache
    onSuccess: (_) => {
      queryClient.invalidateQueries({
        queryKey: ["report-section-data"],
      });
    },
  });
};
